import * as React from 'react';

import { twMerge } from 'tailwind-merge';

import { cn } from '../../../lib';
import { Label } from '../../label';
import { TFloatingLabel, baseVariants } from './types';

export const FloatingLabel: React.FC<TFloatingLabel> = ({
  htmlFor,
  description,
  disabled,
  isInvalid,
  variant,
  className,
  isInput,
  placeholder,
  classNames = {},
  endContent,
  size = 'default',
  children,
  triggerClassName,
  ...props
}) => {
  return (
    <Label htmlFor={htmlFor} className={cn('w-full', className)}>
      <div
        {...props}
        data-disabled={Boolean(disabled)}
        data-is-invalid={Boolean(isInvalid)}
        className={cn(
          baseVariants({ variant, isInvalid, disabled, size }),
          classNames.wrapper,
          triggerClassName,
        )}
      >
        <div
          className={twMerge(
            'relative flex h-full w-full flex-1 items-center gap-2 truncate',
            classNames.content,
          )}
        >
          {children}
          {Boolean(placeholder) && size !== 'sm' && (
            <span
              className={twMerge(
                'pointer-events-none absolute left-0 origin-[0] transition-all duration-200 ease-in-out !typography-16r',
                'text-base-300',
                isInput
                  ? 'top-1/2 -translate-y-1/2 peer-focus:-top-1 peer-focus:translate-y-0 peer-focus:scale-[0.625] peer-focus:leading-[14px] peer-[&:not(:placeholder-shown)]:-top-1 peer-[&:not(:placeholder-shown)]:translate-y-0 peer-[&:not(:placeholder-shown)]:scale-[0.625] peer-[&:not(:placeholder-shown)]:leading-[14px]'
                  : '-top-1 translate-y-0 scale-[0.625] !leading-[14px] peer-empty:top-1/2 peer-empty:-translate-y-1/2 peer-empty:scale-100 peer-empty:!leading-[20px]',

                classNames.placeholder,
              )}
            >
              {placeholder}
            </span>
          )}
        </div>
        {endContent}
      </div>
      {description && (
        <p
          className={twMerge(
            'mt-2 px-[14px] typography-12r',
            'text-base-300',
            classNames.description,
          )}
        >
          {description}
        </p>
      )}
    </Label>
  );
};
